<template lang="pug">

div

    .ui.field.error.message(v-show='$v.$dirty && $v.$invalid') Mindestens eine Rolle angeben

    //- Kunde
    .four.inline.fields(v-show='companyModel.isPurchaser')

        .field
            .ui.toggle.checkbox
                input(type="checkbox" id="customer" v-model='isCustomer')
                label(for='customer') Kunde

    //- Agentur
    .four.inline.fields(v-show='isCompanyAgency')

        .field
            .ui.toggle.checkbox
                input(type="checkbox" id="agency" v-model='isAgency')
                label(for='agency') Agentur

    //- Lieferant
    .four.inline.fields(v-show='companyModel.isSupplier')

        .field
            .ui.toggle.checkbox
                input(type="checkbox" id="supplier" v-model='isSupplier')
                label(for='supplier') Lieferant

    //- Restliche Rollen

    //- Medienproduktion
    .field(v-show='isSystemCompany')
        .ui.toggle.checkbox
            input(type="checkbox" id="media-production" v-model='isMediaProduction')
            label(for='media-production') Medienproduktion

    //- Admin
    .field(v-show='isSystemCompany')
        .ui.toggle.checkbox
            input(type="checkbox" id="admin" v-model='isAdmin')
            label(for='admin') Administration

</template>

<script>
    import compose from 'lodash/fp/compose'
    import defaultTo from 'lodash/fp/defaultTo'
    import property from 'lodash/fp/property'
    import { maybe } from 'maybes'

    //noinspection JSUnusedGlobalSymbols,ReservedWordAsName
    export default {

        computed: {
            isCompanyAgency() {
                if (this.companyModel.isAgency) {
                    return true
                }

                return compose(

                    // Pruefen ob Array mindestens ein Unternehmen/Element haelt
                    length => length > 0,

                    // Laenge des Arrays holen
                    property('length'),

                    // ggf. leeres Default-Array setzen
                    defaultTo([])

                )(this.companyModel.companies)
            },
            isInvalid() {
                return this.$v.$invalid
            },
            isSystemCompany() {
                return this.companyModel.isSystemCompany === true
            },
            roles() {
                return maybe(this.value.roles).orJust([])
            }
        },

        created() {
            this.isCustomer        = this.roles.some(role => role.includes('CUSTOMER'))
            this.isAgency          = this.roles.some(role => role.includes('AGENCY'))
            this.isSupplier        = this.roles.some(role => role.includes('SUPPLIER'))
            this.isAdmin           = this.roles.includes('ADMIN')
            this.isMediaProduction = this.roles.includes('MEDIA_PRODUCTION')
        },

        data() {
            return {
                isAdmin: false,
                isAgency: false,
                isCustomer: false,
                isMediaProduction: false,
                isSupplier: false,
            }
        },

        methods: {

            // TODO: DEPRECATED
            $touch() {
                this.$v.$touch()
            },

            update() {
                const roles = []

                if (this.isCustomer) {
                    roles.push('CUSTOMER')
                }

                if (this.isAgency) {
                    roles.push('AGENCY')
                }

                if (this.isSupplier) {
                    roles.push('SUPPLIER')
                }

                if (this.isAdmin) {
                    roles.push('ADMIN')
                }

                if (this.isMediaProduction) {
                    roles.push('MEDIA_PRODUCTION')
                }

                this.$emit('input', { ...this.value, roles })
            },

            validate() {
                this.$v.$touch()

                if (this.$v.$invalid) {
                    return Promise.reject()
                }

                return Promise.resolve()
            }

        },

        props: {

            companyModel: {
                type: Object,
                required: true
            },

            value: {
                type: Object,
                required: true
            }

        },

        validations: {
            value: {
                required: value => {
                    return Array.isArray(value.roles) && value.roles.length > 0
                }
            }
        },

        watch: {

            isAdmin() {
                this.update()
            },

            isAgency() {
                this.update()
            },

            isCustomer() {
                this.update()
            },

            isMediaProduction() {
                this.update()
            },

            isSupplier() {
                this.update()
            }

        }

    }

</script>
